import {
    NAVIGATION_VIEW,
    NavigationPaths
} from "../navigation/NavigationController"
import { useLocation, useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"

interface TopMenuItemProps {
    children: string
    location: NAVIGATION_VIEW
    action?: boolean
    onClick?: () => void
    onboarding?: boolean
}

function TopMenuItem(props: TopMenuItemProps) {
    const location = useLocation()
    const navigate = useNavigate()

    const [selected, setSelected] = useState<boolean>(false)

    function isSelected() {
        if (props.action !== undefined) {
            return !props.action && selected
        } else return selected
    }

    useEffect(() => {
        setSelected(location.pathname === NavigationPaths[props.location].path)
    }, [location])

    function onClick() {
        if (props.onboarding !== undefined && props.onboarding) {
            alert("Nicht möglich - Onboarding aktiv.")
        } else {
            if (props.action === undefined || !props.action)
                navigate(NavigationPaths[props.location].path)
            else if (props.onClick) props.onClick()
        }
    }

    return (
        <div
            onClick={onClick}
            className={
                props.onboarding !== undefined && props.onboarding
                    ? "tracking-wide font-normal text-white cursor-pointer bg-amber-300 bg-opacity-80 py-0.5 px-3 rounded-2xl"
                    : !isSelected()
                      ? "tracking-wide font-light text-neutral-600 cursor-pointer hover:bg-black hover:bg-opacity-5 hover:text-neutral-800 py-0.5 px-3 rounded-2xl"
                      : "tracking-wide font-normal text-white cursor-pointer bg-black bg-opacity-80 py-0.5 px-3 rounded-2xl"
            }>
            {props.children}
        </div>
    )
}

export default TopMenuItem
